import api from "../../../api/axios";

// D2-D1 — private Deal-linked Viewings transport.
// Server-authoritative endpoints; never use broad property list as auth boundary.

export const fetchViewingsLinkedToDeal = (dealId, { signal } = {}) =>
  api
    .get("/crm/viewings/deal-linked/", { params: { deal: dealId }, signal })
    .then((res) => res.data);

export const fetchViewingDealLinkCandidates = (dealId, { signal } = {}) =>
  api
    .get("/crm/viewings/deal-link-candidates/", {
      params: { deal: dealId },
      signal,
    })
    .then((res) => res.data);

export const linkViewingToDeal = (viewingId, dealId, { signal } = {}) =>
  api
    .patch(
      `/crm/viewings/${viewingId}/`,
      { deal_id: dealId },
      { signal },
    )
    .then((res) => res.data);

export const unlinkViewingFromDeal = (viewingId, { signal } = {}) =>
  api
    .patch(
      `/crm/viewings/${viewingId}/`,
      { deal_id: null },
      { signal },
    )
    .then((res) => res.data);

export const unwrapViewingListPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};
